/** Only local app routes and Passport API's exact authorization endpoint can finish login. */
export function safeLoginReturnUrl(value: string | null, apiUrl: string): string {
  if (!value || /[\\\s#]/.test(value) || /%(?:5c|0a|0d)/i.test(value)) return "/account";
  if (value.startsWith("/") && !value.startsWith("//")) return value;
  return isPassportAuthorizeUrl(value, apiUrl) ? value : "/account";
}

export function isPassportAuthorizeUrl(value: string, apiUrl: string): boolean {
  if (/[\\\s#]/.test(value) || /%(?:5c|0a|0d)/i.test(value)) return false;
  try {
    const configured = new URL(apiUrl);
    const target = new URL(value);
    return ["http:", "https:"].includes(target.protocol)
      && target.origin === configured.origin
      && target.pathname === "/authorize"
      && !target.username && !target.password && !target.hash
      && (value === `${configured.origin}/authorize` || value.startsWith(`${configured.origin}/authorize?`));
  } catch {
    return false;
  }
}
